/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.14.1
 */

import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { EOnboardingComponentsId } from '@/main/modules/onboarding/types/onboardingTypes';

import { icons } from '../../../../../assets';
import { appHistoryPush } from '../../../../../modules/app/appHistory';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { CLIENT_ID, IRouteParams, RoutePath } from '../../../../../routes/constants/routesConstants';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import {
    TTableButtonsGetTranslation,
    TUseTableFooterButtonsOnboarding,
    TUseTableFooterButtonsUrl,
} from '../useTableFooterButtons';

const useTableFooterButtonBillsCompare = (
    getTranslation: TTableButtonsGetTranslation,
    tableFooterName: TableFooterNameType,
) => {
    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link account-compare',
        dataName: 'account-compare',
        icon: icons.compareSheetsIcon,
        id: AccessComponentKeyEnum.FooterButtonAccountCompare,
        ...mapTableFooterNameToOnboarding[tableFooterName],
        ...getTranslation(AccessComponentKeyEnum.FooterButtonAccountCompare),
        onClick: useCallback(() => {
            const urlConfig = mapTableFooterNameToUrl[tableFooterName];
            if (!urlConfig) return;

            appHistoryPush(urlConfig.url.replace(CLIENT_ID, clientId));
        }, [clientId, tableFooterName]),
    };
};

const mapTableFooterNameToUrl: Partial<TUseTableFooterButtonsUrl> = {
    [TableFooterNameType.bills]: {
        url: RoutePath.expensesAnalyzerBillsAccounts,
        external: '',
    },
    [TableFooterNameType.billsUnpaid]: {
        url: RoutePath.expensesAnalyzerBillsUnpaidAccounts,
        external: '',
    },
    [TableFooterNameType.billsAccountId]: {
        url: RoutePath.expensesAnalyzerBillsAccountId,
        external: '',
    },
    [TableFooterNameType.billsUnpaidAccountId]: {
        url: RoutePath.expensesAnalyzerBillsUnpaidAccountId,
        external: '',
    },
};

const mapTableFooterNameToOnboarding: TUseTableFooterButtonsOnboarding = {
    [TableFooterNameType.bills]: {
        onboarding: EOnboardingComponentsId.billsTableFooterButtonCompare,
    },
    [TableFooterNameType.billsUnpaid]: {
        onboarding: EOnboardingComponentsId.billsTableFooterButtonCompare,
    },
    [TableFooterNameType.billsAccountId]: {
        onboarding: EOnboardingComponentsId.billsTableFooterButtonCompare,
    },
    [TableFooterNameType.billsUnpaidAccountId]: {
        onboarding: EOnboardingComponentsId.billsTableFooterButtonCompare,
    },
};

export default useTableFooterButtonBillsCompare;
